<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"  appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

    <div class="add_search_practice_place">
        <div class="add_practice_place"  (click)="addPracticePlace('add')" *ngIf="!addPlace" appChangeColorTheme [isHover]="true">
          <fa-icon [icon]="getFaIcon('faPlus')"  appChangeColorTheme attribute="color"></fa-icon>
          <span>Ajouter un lieu de pratique</span>
        </div>
     
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un lieu de pratique..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">
        </form>

        <fa-icon [icon]="!valueInput? getFaIcon('faSearch'): getFaIcon('faTimes')" (click)="valueInput ? resetSearch(): null" ></fa-icon>

      </div>
    </div>
  </div>

  <div class="content">
    <app-table-practice-club-solo [searchInput]="valueInput"></app-table-practice-club-solo>
  </div>
</div>
